import React from 'react';
import { Navbar } from '../components/layout/Navbar';
import { Footer } from '../components/layout/Footer';
import { HeroSection } from './blog/HeroSection';
import { PostsSection } from './blog/PostsSection';
export function BlogPage() {
  return <div className="min-h-screen flex flex-col bg-brand-black" data-id="element-224">
      <Navbar data-id="element-225" />
      <main className="flex-grow pt-[7.25rem]" data-id="element-226">
        <HeroSection data-id="element-227" />
        <PostsSection data-id="element-228" />
      </main>
      <Footer data-id="element-229" />
    </div>;
}